export default __webpack_public_path__ + "static/jvictoriacollege-ca-hero-image-cfab206edd3db0a41d066f54ea866ede.jpg";